import { ORG_CACHE_KEY, ORG_ROLE } from '@config/index';

export enum ORG_OPERATION {
  READ_MEMBERS,
  SET_ROLE,
  ADD_MEMBER,
  REVIEW_APPLICATION,
  DELETE_MEMBER,
  READ_INFO,
  UPDATE_INFO,
  QUIT_ORG,
  DELETE_ORG,
  CREATE_AGENT
}

export const OrgPermission = (operation: ORG_OPERATION) => {
  const org = JSON.parse(window.sessionStorage.getItem(ORG_CACHE_KEY) || '{}');
  if (org.role === ORG_ROLE.OWNER) {
    return true;
  }
  const columnIndex = org.role === ORG_ROLE.OWNER ? 0 : 1;
  return ORG_PERMISSION_MAP[operation][columnIndex];
};

const ORG_PERMISSION_MAP: { [key: number]: boolean[] } = {
  // [ORG_OPERATION.READ_MEMBERS]: [true, true],
  [ORG_OPERATION.SET_ROLE]: [true, false],
  [ORG_OPERATION.ADD_MEMBER]: [true, false],
  [ORG_OPERATION.REVIEW_APPLICATION]: [true, false],
  [ORG_OPERATION.DELETE_MEMBER]: [true, false],
  [ORG_OPERATION.READ_INFO]: [true, true],
  [ORG_OPERATION.UPDATE_INFO]: [true, false],
  [ORG_OPERATION.QUIT_ORG]: [true, true],
  [ORG_OPERATION.DELETE_ORG]: [true, false],
  [ORG_OPERATION.READ_MEMBERS]: [true, false]
};
